const PRIMARY_BLUE = "#183053";

const Styles = {
  headerTitle: {
    variant: "h6",
    marginLeft: 5,
    fontSize: 20,
    fontWeight: 400,
  },
  menuBarIcon: {
    color: PRIMARY_BLUE,
    alignItems: "start",
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.2)",
    alignSelf: "flex-start",
    marginTop: "1rem",
    "&:hover": { color: "#fff", background: "#2E79E6" },
    "&:active": { color: "#fff", background: "#003E99" },
    position: "absolute",
    left: "-1.5rem",
    zIndex: 100,
  },

  iconButtonEmails: {
    size: "large",
    ariaLabel: "show 4 new mails",
    color: "inherit",
  },

  iconButtonNotification: {
    height: "4px",
    width: "4px",
    top: "24px",
    ariaLabel: "show 17 new notifications",
    color: "#707070",
  },

  appBarStyle: {
    background: "inherit",
    color: "#171B5E",
    boxShadow: "none",
    padding: "0.5rem 2rem",
  },

  containerTypography: {
    mr: 2,
    display: { xs: "none", md: "flex" },
    fontWeight: 700,
    color: "inherit",
    textDecoration: "none",
  },

  typographyLogo: {
    mr: 2,
    display: { xs: "flex", md: "none" },
    flexGrow: 1,
    fontFamily: "monospace",
    fontWeight: 700,
    letterSpacing: ".3rem",
    color: "inherit",
    textDecoration: "none",
  },

  iconButtonBox: {
    display: { xs: "none", md: "flex" },
  },

  menuBox: {
    flexGrow: 1,
    display: { xs: "flex", md: "none" },
  },
  radioContainer: {
    marginLeft: 25,
  },
  userIcon: {
    position: "relative",
    width: 50,
    height: 50,
    background: "#043D902E 0% 0% no-repeat padding-box",
    color: "#66697A",
    border: "1px solid #707070",
    borderRadius: "50%",
    cursor: "pointer",
    boxShadow: "6px 6px 10px #0000001A",
  },
  circle: {
    width: 9,
    height: 9,
    backgroundColor: "#1C9C29",
    position: "absolute",
    bottom: 2,
    right: 2,
    borderRadius: "50%",
  },
  right: {
    display: "flex",
    alignItems: "center",
    gap: 20,
  },
  userInitialsStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    fontSize: "20px",
  },
  profilePhoto: {
    position: "relative",
    width: 51,
    height: 51,
    bottom: 1.2,
    right: 1.1,
    borderRadius: "50%",
    boxShadow: "6px 6px 10px #0000001A",
    cursor: "pointer",
  },
  popup: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
    borderRadius: "10px",
    border: "none",
    outline: "none",
    boxShadow: 24,
    padding: "30px",
  },
  title: {
    color: "#8C8C8C",
    fontSize: 20,
    fontWeight: 500,
  },
};
export default Styles;
